import { useCallback, useRef } from 'react';
import { EVENT_KEYS, trackLoad } from '../services/api/trackingService';

const viewedTooltips = new Set<string>();

const DEBOUNCE_MS = 500;

export const useTooltipTracking = (tooltipId: string) => {
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const onOpenChange = useCallback(
        (open: boolean) => {
            if (open && !viewedTooltips.has(tooltipId)) {
                timerRef.current = setTimeout(() => {
                    viewedTooltips.add(tooltipId);
                    trackLoad(EVENT_KEYS.tooltipView, { tooltipId });
                }, DEBOUNCE_MS);
            } else if (!open && timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        },
        [tooltipId]
    );

    return onOpenChange;
};
